export default [
  {
    path: '/rent/v2/order',
    name: 'order',
    component: () => import('@/pages/order/index'),
    meta: { title: '订单', requireAuth: true },
    children: [
      {
        path: 'confirm',
        name: 'orderConfirm',
        component: () => import('@/pages/order/confirmOrder'),
        meta: { title: '确认订单', requireAuth: true },
      },
      {
        path: 'moreRights',
        name: 'moreRights',
        component: () => import('@/pages/order/moreRights'),
        meta: { title: '更多权益', requireAuth: true },
      },
      {
        path: 'coupons',
        name: 'orderCoupons',
        component: () => import('@/pages/order/coupons'),
        meta: { title: '优惠券', requireAuth: true },
      },
      {
        path: 'round',
        name: 'orderRound',
        component: () => import('@/pages/order/roundProduct'),
        meta: { title: '周边商品', requireAuth: true },
      },
      {
        path: 'shop',
        name: 'orderShop',
        component: () => import('@/pages/order/chooseShop'),
        meta: { title: '选择门店', requireAuth: true },
      },
      {
        path: 'orderList',
        name: 'orderList',
        component: () => import('@/pages/order/orderList'),
        meta: { title: '我的订单', requireAuth: true },
      },
      {
        path: 'insurance',
        name: 'orderInsurance',
        component: () => import('@/pages/order/insurance'),
        meta: { title: '保险', requireAuth: true },
      },
      {
        path: 'policy',
        name: 'orderPolicy',
        component: () => import('@/pages/order/policy'),
        meta: { title: '投保人信息', requireAuth: true },
      },
      {
        path: 'submit',
        name: 'orderSubmit',
        component: () => import('@/pages/order/submitOrder'),
        meta: { title: '提交订单', requireAuth: true },
      },
      {
        path: 'detail',
        name: 'orderDetail',
        component: () => import('@/pages/order/detail'),
        meta: { title: '订单详情', requireAuth: true },
      },
      {
        path: 'comment',
        name: 'postComment',
        component: () => import('@/pages/order/postComment'),
        meta: { title: '发表评论', requireAuth: true },
      },
      {
        path: 'cancelReason',
        name: 'orderCancelReason',
        component: () => import('@/pages/order/cancelReason'),
        meta: { title: '取消原因', requireAuth: true },
      },
      {
        path: 'couponOrderDetail',
        name: 'couponOrderDetail',
        component: () => import('@/pages/order/couponOrderDetail'),
        meta: { title: '订单详情', requireAuth: true },
      },
      {
        path: 'couponOrderConfirmOrder',
        name: 'couponOrderConfirmOrder',
        component: () => import('@/pages/order/couponOrderConfirmOrder'),
        meta: { title: '确认订单', requireAuth: true },
      },
      {
        path: 'couponOrderList',
        name: 'couponOrderList',
        component: () => import('@/pages/order/couponOrderList'),
        meta: { title: '优惠商城订单列表', requireAuth: true },
      },
      {
        path: 'commentList',
        name: 'commentList',
        component: () => import('@/pages/order/commentList'),
        meta: { title: '更多评论', requireAuth: true },
      },
      {
        path: 'complain',
        name: 'complain',
        component: () => import('@/pages/order/complain'),
        meta: { title: '举报', requireAuth: true },
      },
      {
        path: 'sdzConfirmOrder',
        name: 'sdzConfirmOrder',
        component: () => import('@/pages/order/sdzConfirmOrder'),
        meta: { title: '确认订单', requireAuth: true },
      },
      {
        path: 'travelConfirmOrder',
        name: 'travelConfirmOrder',
        component: () => import('@/pages/order/travelConfirmOrder'),
        meta: { title: '确认订单', requireAuth: true },
      },
      {
        path: 'camperOrderDetail',
        name: 'camperOrderDetail',
        component: () => import('@/pages/order/camperOrderDetail'),
        meta: { title: '订单详情', requireAuth: true },
      },
      {
        path: 'needKnow',
        name: 'needKnow',
        component: () => import('@/pages/order/needKnow'),
        meta: { title: '预订须知', requireAuth: false },
      },
      {
        path: 'travelOrderDetail',
        name: 'travelOrderDetail',
        component: () => import('@/pages/order/travelOrderDetail'),
        meta: { title: '订单详情', requireAuth: true },
      },
      {
        path: 'travelOrderList',
        name: 'travelOrderList',
        component: () => import('@/pages/order/travelOrderList'),
        meta: { title: '订单列表', requireAuth: true },
      },
      {
        path: 'butlerKnow',
        name: 'butlerKnow',
        component: () => import('@/pages/order/butlerKnow'),
        meta: { title: '房车管家', requireAuth: false },
      },
      {
        path: 'customOrderDetail',
        name: 'customOrderDetail',
        component: () => import('@/pages/order/customOrderDetail'),
        meta: { title: '订单详情', requireAuth: true },
      },
      {
          path: 'comprehensiveCampOrderDetail',
          name: 'comprehensiveCampOrderDetail',
          component: () => import('@/pages/order/comprehensiveCampOrderDetail'),
          meta: { title: '订单详情', requireAuth: true },
      },
      {
        path: 'campsiteConfirmOrder',
        name: 'campsiteConfirmOrder',
        component: () => import('@/pages/order/campsiteConfirmOrder'),
        meta: { title: '确认订单', requireAuth: true },
      },
      {
        path: 'verification',
        name: 'verification',
        component: () => import('@/pages/order/verification'),
        meta: { title: '核销码', requireAuth: true },
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/pages/order/order.js